import { useCallback } from 'react';
import { useHistory } from 'react-router-dom';

import { INFO_BOX } from 'store/infoItems';

export const useTogglePanel = () => {
  const { push, location } = useHistory();
  const { hash, pathname, state } = location;

  return [hash === `#${INFO_BOX}`, useCallback(() => push(pathname, state), [pathname, push, state])];
};
